export function generateCorrelationId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // RFC4122 v4 fallback for environments without crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

interface ActiveRequest {
  correlationId: string;
  method: string;
  path: string;
  startedAt: number;
}

const active = new Map<string, ActiveRequest>();
const recentIds: string[] = [];
const RECENT_LIMIT = 50;

export function trackRequestStart(method: string, path: string): ActiveRequest {
  const correlationId = generateCorrelationId();
  const entry: ActiveRequest = {
    correlationId,
    method,
    path,
    startedAt: performance.now(),
  };
  active.set(correlationId, entry);
  recentIds.push(correlationId);
  if (recentIds.length > RECENT_LIMIT) recentIds.shift();
  return entry;
}

export function trackRequestEnd(correlationId: string): number {
  const entry = active.get(correlationId);
  active.delete(correlationId);
  if (!entry) return 0;
  return Math.round(performance.now() - entry.startedAt);
}

export function getRecentCorrelationIds(): string[] {
  return [...recentIds];
}

export function clearCorrelationHistory(): void {
  active.clear();
  recentIds.length = 0;
}
